export default () => ({ ak: 'iAqYq2ZdH0GbmtjOAktt', sk: 'XbPCUVGwvel74bwyznIZKt15uO5rvCNLogT4AWao'})